//@flow
import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import ThumbnailUtil from '../../util/ThumbnailUtil';
import ErrorHandler from '../../error/ErrorHandler';
import PropTypes from 'prop-types';
import ReadFavItems from '../../queries/fav/ReadFavItems';
import { FAV_ITEM_DETAIL_MAP } from '../../store/Constants';
import Store from '../../store/Store';
import {removeFavItem} from '../../queries/fav/FavoriteUtil';
import { isMobile } from '../../util/ScreenUtil';
import LazyLoader from 'react-lazy-load';
import ImageLoader from '../../common/imageloader/ImageLoader';
import '../../common/imageloader/ImageLoader.css';
import './FavoriteContent.css';
import { RepoItem } from '../../autogenerated/ZoomBridge';
import t from '../../i18n/I18n';
import { TextWithEllipsisFileExtension } from '../../common/TextWithEllipsis';
import { ThemeSetup } from '../../themes/ThemeSetup';

const debug = require('../../debug/debug')('wc:util:CollectionUtil');

export default class FavoriteContent extends React.Component {
  constructor() {
    super();
    this.state = {
      showSpan: false,
      favItems: Store.get(FAV_ITEM_DETAIL_MAP)
    };
  }

  componentWillMount() {
    this._ismounted = true;
    Store.addListener(FAV_ITEM_DETAIL_MAP, (e) => {
      if (this._ismounted) {
        this.setState({ favItems: e.data });
      }
    });
    this.issueReadFavItemsQuery();
  }

  static propTypes = {
    onAssetClick: PropTypes.func,
    styleHeader: PropTypes.any
  };

  issueReadFavItemsQuery() {
    new ReadFavItems().run();
  }

  componentWillUnmount() {
    this._ismounted = false;
    Store.removeListener(FAV_ITEM_DETAIL_MAP, () => {});
  }

  reload(): void {
    new ReadFavItems().run();
  }

  getThumbUrl(content: Any) {
    if (!content.isIsFile()) {
      return ThemeSetup.getImageURL('folder.svg');
    } else {
      return ThumbnailUtil.getThumnailUrl(true, content.getBid(), content.getFuid(), -1, content.getName());
    }
  }

  render() {
    const showFav = this.state.favItems && this.state.favItems.size();
    if (isMobile()) {
      return (
        <div>
          {showFav ? (
            <div>
              <div className="field-label" style={{ display: 'unset' }}>
                <div>

                    {t('TOOLTIP_TEXTS.FAVORITE_CONTENT')} ({this.state.favItems.size()})
                  <img onClick={this.reloadFav} src="images/refresh.svg" className="reloadImage" />
                </div>
              </div>
              <div className="fav-wrapper-outer">
                <div className="fav-wrapper-inner" style={this.props.mobStyle}>
                  <div name="FavoriteContent">
                    {_.map(this.state.favItems.values(), (content) => this.renderItem(content))}
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      );
    }
    return (
      <div style={{ margin: '40px -60px 0 0' }}>
        {showFav ? (
          <div>
            <div style={this.props.styleHeader}>
              {t('FAVORITE_CONTENT_UPPERCASE')} ({this.state.favItems.size()}){' '}
              <img onClick={this.reload} src="images/refresh.svg" style={reloadimage} />
            </div>
            <div name="FavoriteContent">
              {_.map(this.state.favItems.values(), (content) => this.renderItem(content))}
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  renderItem(content) {
    const styles = {
      // body: {
      //   backgroundImage: `url(${ThumbnailUtil.getThumnailUrl(
      //     true,
      //     content.getBid(),
      //     content.getFuid(),
      //     -1,
      //     content.getName()
      //   )})`
      // },
      starIconFull: {
        backgroundImage: 'url(images/icons_star_filled.svg)'
      }
    };

    const isDisplayStar = this.state.showSpan === content.getFuid() ? 'inline-block' : 'none';

    return (
      <div className="item" key={content.getFuid()}>
        <div
          className="content"
          onClick={() => this.props.onAssetClick(content)}
          onMouseEnter={() => this.setState({ showSpan: content.getFuid() })}
          onMouseLeave={() => this.setState({ showSpan: false })}>
          {/* <div className="body" style={{ ...styles.body }} /> */}
          <div>
            <LazyLoader offsetVertical={0}>
              <div className={classNames('body', { folder: !content.isIsFile() })}>
              <ImageLoader
                style={content.isIsFile() ? null : folderThumbStyle}
                src={this.getThumbUrl(content)}
              />
              </div>
            </LazyLoader>
          </div>
          <div className="footer" style={styles.footer}>
            <span className="field-label" style={{ display: isMobile() ? 'unset' : null }}>
              {content.getAssetType() || 'image'}
            </span>
            <span
              style={{
                ...styles.starIconFull,
                display: isMobile() ? 'inline-block' : isDisplayStar,
                height: '16px',
                width: '18px',
                marginLeft: '5px',
                backgroundSize: '18px 16px'
              }}
              onClick={(event) => {
                event.stopPropagation();
                this.removeFavItem(content);
              }}
            />
            <div className="asset-name">
              <TextWithEllipsisFileExtension
                title={content.getName()}
                text={content.getName()}
                style={{
                  fontSize: '16px',
                  margin: '0px 0px 10px'
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  removeFavItem(asset: RepoItem) {
    removeFavItem(asset).then(
      (resp) => {
        debug('[removeFavItem()] resp: ', resp);
      },
      (error) => {
        ErrorHandler.handleError(error);
      }
    );
  }

  getThumbnailUrl(item) {
    return ThumbnailUtil.getThumnailUrl(item.isIsFile(), item.getBid(), item.getFuid(), -1, item.getName());
  }
}

const mobileViewStyle = {
  display: 'inline-flex'
};
const reloadimage = {
  cursor: 'pointer',
  width: '14px'
};
const folderThumbStyle = {
  objectFit: 'contain'
};
